// source: https://github.com/vercel/swr/issues/110#issuecomment-552637429
import { useState, useEffect } from "react";

export function useDebounce(value, delay) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}

/**
 * Usage with swr

import useSWR from 'swr';
...
// inside component render method
const [search, setSearch] = useState('');
const debouncedSearch = useDebounce(search, 1000);
const { data: res, isValidating } = useSWR(
  () =>
    debouncedSearch ? `/api/suggestion?value=${debouncedSearch}` : null,
  fetcher
);

*
*/
